import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

export default class InlineOrderedBox extends Component {
  static propTypes = {
    contentList: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        mainContent: PropTypes.any,
        footer: PropTypes.shape({
          text: PropTypes.string,
          icon: PropTypes.oneOf(["up", "down", "noop"])
        })
      })
    ),
    size: PropTypes.oneOf(["large", "small"])
  };

  static defaultProps = {
    contentList: []
  };

  render() {
    const { size, contentList } = this.props;
    return (
      <BoxWrapper size={size}>
        {contentList.map((item, index) => {
          return (
            <SingleBox size={size} index={index} key={index}>
              <Title size={size}>{item.title.toUpperCase()}</Title>
              <MainContent size={size}>{item.mainContent}</MainContent>
              <Footer size={size}>{item.footer.text}</Footer>
            </SingleBox>
          );
        })}
      </BoxWrapper>
    );
  }
}

const OrderedBoxTheme = {
  BoxWrapper: {
    large: css`
      background-color: #21445a;
      flex: 1;
      height: 200px;
      margin: 10px;
      border-radius: 5px;
      display: flex;
      flex-direction: row;
    `,
    small: css`
      height: 150px;
      border: solid 2px #ebeef7;
      justify-content: center;
      text-align: center;
      margin: 10px;
      display: flex;
      flex-direction: row;
    `
  },
  SingleBox: {
    large: css`
      text-align: center;
      margin-top: 13px;
      margin-bottom: 11px;
      flex-grow: 1;
    `,
    small: css`
      margin-top: 10px;
      margin-bottom: 10px;
      text-align: center;
      padding: 0 30px;
      flex-grow: 1;
    `
  },
  Title: {
    large: css`
      width: 100%;
      height: 10%;
      margin-top: 0px;
    `,
    small: css`
      color: #087cbc;
      font-size: 16px;
      text-align: center;
      margin-bottom: 10px;
    `
  },
  MainContent: {
    large: css`
      width: 100%;
      height: 10%;
      font-weight: bold;
      font-size: 45px;
      margin: 37px 40px 77px 0;
    `,
    small: css`
      font-weight: bold;
      color: #59585b;
      font-size: 33px;
      text-align: center;
      margin-bottom: 10px;
    `
  },
  Footer: {
    large: css`
      width: 100%;
      height: 10%;
    `,
    small: css`
      color: #59585b;
      text-align: center;
      margin-bottom: 10px;
    `
  }
};

const BoxWrapper = styled.div`
  ${props => OrderedBoxTheme.BoxWrapper[props.size]} flex-direction: row;
`;

const SingleBox = styled.div`
  ${props => OrderedBoxTheme.SingleBox[props.size]} 
  ${props =>
      props.index > 0 && props.size === "large" &&
      css`
        border-left: solid 2px white;
      `} 
  ${props =>
      props.index > 0 &&
      props.size === "small" &&
      css`
        border-left: solid 2px #ebeef7;
      `};
`;

const Title = styled.div`
  ${props => OrderedBoxTheme.Title[props.size]};
`;

const MainContent = styled.div`
  ${props => OrderedBoxTheme.MainContent[props.size]};
`;

const Footer = styled.div`
  ${props => OrderedBoxTheme.Footer[props.size]};
`;



// WEBPACK FOOTER //
// ./src/module-analytics/components/InlineOrderedBox.js